import { useContext } from "react";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { AiOutlineClose } from "react-icons/ai";
import { FiCheck, FiSearch } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { SocketContext } from "../../context/SocketContext";

import {
    acceptMessageRequest,
    rejectMessageRequest
} from "../../redux/ApiSlice/MessagesSlice";
import SkeletonOne from "../../components/skeleton/SkeletonOne";

export default function MessageRequest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchTerm, setSearchTerm] = useState("");

    // Get messageRequestList from socket context if available, else fallback to redux
    const { messageRequestList: messageRequestListSocket } = useContext(SocketContext);
    const { messageRequests, loading, acceptRequestLoading, rejectRequestLoading } = useSelector(state => state.messages);

    // Prefer socket data if connected, else fallback to redux
    const requests = Array.isArray(messageRequestListSocket?.data) && messageRequestListSocket.isConnected
        ? messageRequestListSocket.data
        : (Array.isArray(messageRequests?.message_request_list)
            ? messageRequests.message_request_list
            : Array.isArray(messageRequests)
                ? messageRequests
                : []);

    const filteredRequests = requests.filter(item => {
        const user = item.users?.[0];
        const fullName = user ? `${user.full_name}` : "";
        return fullName.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const handleAccept = (id) => {
        dispatch(acceptMessageRequest(id));
    };

    const handleReject = (id) => {
        dispatch(rejectMessageRequest(id));
    };

    return (
        <div className="h-full bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-10">
                <div className="relative bg-[#BDE6FF] rounded-b-xl h-12 flex items-center justify-center">
                    <IoMdArrowBack
                        onClick={() => navigate(-1)}
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-[22px] text-black dark:text-black cursor-pointer"
                    />
                    <p className="font-bold text-[18px] text-black dark:text-black">Requests</p>
                </div>

                <div className="px-3 py-2 bg-white dark:bg-[#1E1D21]">
                    <div className="relative">
                        <FiSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-800 dark:text-white" />
                        <input
                            type="text"
                            value={searchTerm}
                            placeholder="Search requests..."
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="rounded-full text-[14px] w-full py-1.5 pr-8 pl-3 bg-gray-100 dark:bg-[#333333] text-black dark:text-white border border-gray-900 outline-none"
                        />
                    </div>
                </div>
            </div>

            {loading ? (
                <SkeletonOne />
            ) : filteredRequests.length > 0 ? (
                filteredRequests.map((item) => {
                    const user = item.users?.[0];
                    return (
                        <div key={item.id} className="grid grid-cols-12 px-2 py-1.5 bg-white dark:bg-[#1E1D21] border-b border-gray-300/50 dark:border-gray-900/50 cursor-pointer">
                            <div className="grid grid-cols-7 col-span-7">
                                <div className="col-span-7 flex items-center justify-start relative">
                                    <img
                                        src={user?.avatar_url}
                                        className="h-9 w-9 shadow-2xl object-cover rounded-full"
                                        onClick={() => navigate(`/account/${user?.id}`)}
                                        alt={user ? `${user.full_name}` : "User"}
                                    />
                                    {item.unread_messages > 0 && (
                                        <span className="absolute -top-1 left-6 bg-red-500 text-white text-[10px] h-4 w-4 rounded-full flex items-center justify-center">
                                            {item.unread_messages}
                                        </span>
                                    )}

                                    <div className="flex flex-col ml-3">
                                        <p
                                            onClick={() => navigate(`/account/${user?.id}`)}
                                            className="text-black dark:text-white text-[14px] line-clamp-1"
                                        >
                                            {user ? `${user.full_name}` : "Unknown User"}
                                        </p>
                                        <p
                                            onClick={() => navigate(`/account/${user?.id}`)}
                                            className="text-black dark:text-white text-[14px] line-clamp-1"
                                        >
                                            {user.username ? `${user.username}` : "Unknown User"}
                                        </p>
                                        {/* {item.latest_message && (
                                            <p className="text-gray-500 dark:text-gray-400 text-[12px] line-clamp-1">
                                                {item.latest_message.message}
                                            </p>
                                        )} */}
                                    </div>
                                </div>

                            </div>
                            <div className="col-span-5 flex justify-end items-center gap-[5px]">
                                <button
                                    type="button"
                                    onClick={() => handleAccept(item.id)}
                                    className="bg-[#BDE6FF] text-black px-2 py-1 rounded-md"
                                    disabled={acceptRequestLoading}
                                >
                                    Accept
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleReject(item.id)}
                                    className="bg-gray-200 dark:bg-[#333333] text-gray-900 dark:text-gray-100 text-[10px] p-1 rounded-lg"
                                >
                                    <AiOutlineClose className="text-[16px]" />
                                </button>
                            </div>
                        </div>
                    );
                })
            ) : (
                <p className="text-[12px] text-center mt-20 text-gray-600 dark:text-gray-700">
                    No requests found...
                </p>
            )}
        </div>
    );
}